module.exports = __webpack_public_path__ + "img/Magazin_Kachel.485e8f47.jpg";